import React , { Component } from "react";
import $ from 'jquery';
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

class PreviewHeader extends Component{
    updatePreview = (e) => {

        document.querySelectorAll(".btn").forEach(e => {
            e.classList.remove("active");
        });

        document.querySelector(`.${e}`).classList.add("active");

        if (e == 'p_desktop') {

            document.querySelectorAll(".device").forEach(e => {
                e.classList.remove("device-tablet-p");
                e.classList.remove("device-mobile-p");
            });

            document.querySelector(`.device`).classList.add("device-desktop");
        }

        if (e == 'p_tablet') {

            document.querySelectorAll(".device").forEach(e => {
                e.classList.remove("device-desktop");
                e.classList.remove("device-mobile-p");
            });

            document.querySelector(`.device`).classList.add("device-tablet-p");

            $(".device-tablet-p").width();
            $(".device-tablet-p").height();
        }

        if (e == 'p_mobile') {

            document.querySelectorAll(".device").forEach(e => {
                e.classList.remove("device-tablet-p");
                e.classList.remove("device-desktop");
            });

            document.querySelector(`.device`).classList.add("device-mobile-p");
        }
    }
    render(){
        const { backAction, step } = this.props;
        return <div className="preview_header">
        <div className="sub_header_top subheader py-2">
            <div className="container-fluid">
                <div className="preview_cont">
                    <div className="row">
                    <div className="col-md-5 col-sm-5 col-4 ps-0">
                        <Button variant="link" className="border-0 px-3 py-2 rounded-0 h-100" data-factors-click-bind="true" onClick={backAction}>
                            <FontAwesomeIcon type={'regular'} icon={'chevron-left'} iconClass={'text-dark fs-4'} />
                        </Button>
                    </div>
                    {step < 3 ? <div className="col-md-2 col-sm-4 col-8">
                        <ul className="d-flex align-items-center list-inline mb-0 flex-nowrap p_device_btn">
                            <li className="nav-item">
                                <Button variant="" className="border-0 rounded-0 btn-clean me-1 preview_btn p_desktop active" data-factors-click-bind="true" onClick={()=>this.updatePreview('p_desktop')}>
                                    <FontAwesomeIcon type={'regular'} icon={'display'} iconClass={'text-dark'} />
                                </Button>
                            </li>
                            <li className="nav-item">
                                <Button variant="" className="btn-clean rounded-0 preview_btn p_mobile" data-factors-click-bind="true"  onClick={()=>this.updatePreview('p_mobile')}>
                                    <FontAwesomeIcon type={'regular'} icon={'mobile'} iconClass={'text-dark'} />
                                </Button>
                            </li>
                        </ul>
                    </div> : null}
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
}

export default PreviewHeader


                